import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Divider, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";

import {
  getAllEmployeeName,
  getAllTrainingName,
  getEmployeesByGroup,
  getGroupDropdown,
  getLocationDropdown,
  getRecommendedEmpByTraining,
  getTrainerDropdown,
  getTrainingMasterInfo,
  saveTrainingSchedule,
} from "../../services/TrainingServices";
import { CloseModalIcon } from "../../../common/components/assets/commonassets/CommonAssets";
import CommonDivider from "../../../common/components/divider/CommonDivider";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import DatePickerField from "../../../common/components/FormFields/DatePickerFieldNew";
import TimePickerFieldNew from "../../../common/components/FormFields/TimePickerFieldNew";
import DropdownField from "../../../common/components/FormFields/DropdownField";
import CommonDynamicTableNew from "../../../common/components/CommonTable/CommonDynamicTableNew";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
import { DeleteIcon, NoRecordsIcon } from "../../../assets/CommonAssets";
import {
  errorAlert,
  successAlert,
} from "../../../common/components/Toasts/CustomToasts";
import CheckBoxField from "../../../common/components/FormFields/CheckBoxField";
import { UseCheckConsecutiveCharacters } from "../../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";
import RadioField from "../../../common/components/FormFields/RadioField";
import ControlledRadioField from "../../../common/components/FormFields/ControlledRadioField";

const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  height: "auto",
  minHeight: "660px",
  bgcolor: "background.paper",
  border: "1px solid gray",
  overflowY: "visible",
  boxShadow: 20,
  p: 2,
  display: "flex", // ← add
  flexDirection: "column", // ← add
};
const TrainingScheduleModal = ({
  setTrainingScheduleModalOpen,
  trainingScheduleModalOpen,
  selectedRow,
  setSelectedRow,
  populateTable,
  setOpenBackdrop,
  openBackDrop,
  setTrainingScheduleList,
  selectedRowPatchData,
  setSelectedRowPatchData,
}) => {
  const [employeeNameOptions, setEmployeeNameOptions] = useState([]);
  const [trainingNameOptions, setTrainingNameOptions] = useState([]);
  const [recommandedEmployees, setRecommandedEmployees] = useState([]);
  const [finalData, setFinalData] = useState([]);
  const [openPostModal, setOpenPostModal] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [selectedTraining, setSelectedTraining] = useState(null);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [spinner, showSpinner] = React.useState(false);
  const [groupDropdown, setGroupDropdown] = useState([]);
  const [trainerDropdown, setTrainerDropdown] = useState([]);
  const [locationDropdown, setLocationDropdown] = useState([]);
  const isReschedule = selectedRow && selectedRow.edit === false;
  const defaultValues = {
    training: null,
    trainingDate: null,
    assignRole: null,
    assignStaff: null,
    fromTime: null,
    toTime: null,
    group: null,
  };
  const userActions = [
    {
      id: 0,
      permission: "Edit",
      isAction: true,
    },
    {
      id: 1,
      permission: "Delete",
      isAction: true,
    },
    {
      id: 2,
      permission: "Create",
      isAction: false,
    },
  ];

  const schema = yup.object({
    training: yup.object().nullable().required("Training is required"),
    trainingDate: yup
      .date()
      .nullable()
      .required("Training date is required")
      .typeError("Invalid training date"),

    fromTime: yup
      .date()
      .nullable()
      .required("From time is required")
      .typeError("Invalid from time"),

    toTime: yup
      .date()
      .nullable()
      .required("To time is required")
      .typeError("Invalid to time"),
  });

  const {
    handleSubmit,
    reset,
    control,
    watch,
    formState: { errors },
    setValue,
  } = useForm({ defaultValues, resolver: yupResolver(schema) });
  const assignStaff = watch("assignStaff");
  let watchMode = watch("mode");
  const watchTraining = watch("training");
  let watchGroup = watch("group");
  // let watchTrainingDate = watch("trainingDate");
  // let watchFromTime = watch("fromTime");
  // let watchToTime = watch("toTime");

  const onSubmit = (formData) => {
    if (!selectedTraining) return;
    if (selectedTraining?.trainingTypeId === 3) {
      if (!formData?.trainerName) {
        errorAlert("Trainer name is required");
        return;
      }
      if (!formData?.mode) {
        errorAlert("Mode is required");
        return;
      }
      if (Number(formData?.mode) === 2 && !formData?.location) {
        errorAlert("Location is required");
        return;
      }
    }

    const finalObject = {
      id: selectedRow !== null ? selectedRow?.["Training Schedule Id"] : null,
      training: watchTraining
        ? {
            id: watchTraining?.id,
          }
        : null,
      trainer: formData?.trainerName
        ? {
            id: formData?.trainerName?.id || formData?.trainerName?.value,
          }
        : null,
      mode:
        selectedTraining?.trainingTypeId === 3 && formData?.mode
          ? { id: formData?.mode }
          : null,
      location:
        watchMode === 2 && formData?.location
          ? {
              id: formData?.location?.id || formData?.location?.value,
            }
          : null,
      trainingDate: new Date(formData?.trainingDate).getTime(),
      fromTime: new Date(formData?.fromTime).getTime(),
      toTime: new Date(formData?.toTime).getTime(),
      isActive: true,
      trainingStaffDetailsRequestDtos:
        selectedEmployees?.length > 0
          ? selectedEmployees?.map((obj) => {
              return {
                employee: {
                  id: obj?.id,
                },
                // ,
                // group: {
                //   id: obj.id,
                // },
              };
            })
          : null,
    };

    setFinalData(finalObject);
    setOpenPostModal(true);
  };

  const renderActionsEmp = (row, index) => {
    return (
      <div className="flex gap-0 items-center">
        {userActions.map((actions, i) => (
          <>
            {actions.isAction === true ? (
              <div className="flex gap-2 cursor-pointer">
                {actions.permission === "Delete" && !isReschedule ? (
                  <button
                    type={"button"}
                    onClick={() => handleDeleteEmployee(row)}
                  >
                    <DeleteIcon
                      sx={{ color: "#D11A2A" }}

                      // onClick={() => {
                      //   setOpenDeleteModal(true);
                      //   setSelectedRow(row);
                      // }}
                    />
                  </button>
                ) : null}
              </div>
            ) : null}
          </>
        ))}
      </div>
    );
  };

  const handleSaveRecord = () => {
    // setTrainingScheduleList((prev) => [...prev, ...finalData]);
    setOpenPostModal(false);
    setTrainingScheduleModalOpen(false);
    setOpenBackdrop(true);
    saveTrainingSchedule(finalData)
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 201 || res.statusCode === 200) {
          setSelectedEmployees([]);
          setTrainingScheduleModalOpen(false);
          populateTable();
          setSelectedRow(null);
          successAlert(res.message);
          setOpenBackdrop(false);
          reset(defaultValues);
        }
      })
      .catch((error) => {
        errorAlert(error.message);
        setOpenBackdrop(false);
      });
  };

  useEffect(() => {
    if (!assignStaff) return;

    setSelectedEmployees((prev) => {
      const exists = prev?.some((emp) => emp.id === assignStaff.id);
      if (exists) return prev;
      return [
        ...prev,
        {
          id: assignStaff?.id,
          employees: assignStaff?.label,
        },
      ];
    });

    setValue("assignStaff", null);
  }, [assignStaff]);

  const handleDeleteEmployee = (row) => {
    setSelectedEmployees((prev) => prev.filter((emp) => emp.id !== row.id));
  };
  useEffect(() => {
    getGroupDropdown()
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 200) {
          setGroupDropdown(res?.result);
        }
      })
      .catch((error) => errorAlert(error?.message));
  }, []);

  useEffect(() => {
    if (!watchTraining) {
      setSelectedTraining(null);
    }
  }, [watchTraining]);

  useEffect(() => {
    getTrainerDropdown()
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 200) {
          setTrainerDropdown(res?.result);
        }
      })
      .catch((error) => errorAlert(error?.message));
  }, []);

  useEffect(() => {
    getLocationDropdown()
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 200) {
          setLocationDropdown(res?.result);
        }
      })
      .catch((error) => errorAlert(error?.message));
  }, []);
  useEffect(() => {
    if (watchTraining !== null && watchTraining?.id) {
      // console.log(watchTraining, "watchTraining");
      setOpenBackdrop(true);
      getTrainingMasterInfo(watchTraining?.id)
        .then((response) => response.data)
        .then((res) => {
          if (res.statusCode === 200) {
            const finalData = JSON.parse(res.result);
            // console.log(finalData, "patientData");
            setSelectedTraining(finalData);
            setOpenBackdrop(false);
          }
        })
        .catch((error) => {
          errorAlert(error.message);
          setOpenBackdrop(false);
        });
    }
  }, [watchTraining]);

  useEffect(() => {
    if (watchTraining !== null && watchTraining?.id) {
      // console.log(watchTraining, "watchTraining");
      setOpenBackdrop(true);
      getRecommendedEmpByTraining(watchTraining?.id)
        .then((response) => response.data)
        .then((res) => {
          if (res.statusCode === 200) {
            // const finalData = JSON.parse(res.result);
            // console.log(finalData, "patientData");
            setRecommandedEmployees(res?.result);
            setOpenBackdrop(false);
          }
        })
        .catch((error) => {
          errorAlert(error.message);
          setOpenBackdrop(false);
        });
    } else {
      setRecommandedEmployees([]);
    }
  }, [watchTraining]);

  useEffect(() => {
    if (watchGroup !== null && watchGroup?.id) {
      // console.log(watchGroup, "watchGroup");
      getEmployeesByGroup(watchGroup?.id)
        .then((response) => response.data)
        .then((res) => {
          if (res.statusCode === 200) {
            let finalData = res.result;
            let filteredData = finalData.map((obj) => ({
              employees: obj?.label,
              id: obj?.id,
              value: obj?.value,
            }));

            setSelectedEmployees((prev) => {
              const newEmployees = filteredData.filter(
                (emp) => !prev.some((existing) => existing.id === emp.id),
              );
              return [...prev, ...newEmployees];
            });

            // console.log(res?.result, "result");
          }
        })
        .catch((error) => errorAlert(error?.message));
    }
  }, [watchGroup]);

  useEffect(() => {
    if (selectedRowPatchData !== null) {
      setValue("location", selectedRowPatchData?.location);
      setValue("training", selectedRowPatchData?.training);
      setValue("trainerName", selectedRowPatchData?.trainer);
      setValue("locationId", selectedRowPatchData?.locationId);
      setValue("trainingDate", new Date(selectedRowPatchData?.trainingDate));
      setValue("fromTime", new Date(selectedRowPatchData?.fromTime));
      setValue("toTime", new Date(selectedRowPatchData?.toTime));
      setValue("mode", selectedRowPatchData?.mode?.id);
      setValue("isActive", selectedRowPatchData?.isActive);
      watchMode === 2 && setValue("location", selectedRowPatchData?.location);
      setSelectedEmployees(
        (selectedRowPatchData?.staffDetails ?? []).map((staff) => ({
          id: staff?.employeeId,
          employees: staff?.employeeName,
        })),
      );
    }
    // }
  }, [selectedRowPatchData]);

  //for recommended employee add into selected employee
  // useEffect(() => {
  //   const checkedEmployees = recommandedEmployees?.filter(
  //     (emp) => emp?.isChecked === true,
  //   );

  //   if (checkedEmployees?.length === 0) return;

  //   setSelectedEmployees((prev) => {
  //     const newEmployees = checkedEmployees
  //       .filter((emp) => !prev.some((e) => e.id === emp.id))
  //       .map((emp) => ({
  //         id: emp?.id,
  //         value: emp?.value,
  //         employees: emp?.Employees,
  //         is_recommended: true,
  //       }));

  //     return [...prev, ...newEmployees];
  //   });
  // }, [recommandedEmployees]);
  useEffect(() => {
    const checkedEmployees = recommandedEmployees?.filter(
      (emp) => emp?.isChecked === true,
    );

    if (checkedEmployees?.length === 0) return;

    setSelectedEmployees((prev) => {
      const duplicateEmployees = checkedEmployees.filter((emp) =>
        prev?.some((e) => e?.id === emp?.id),
      );

      if (duplicateEmployees.length > 0) {
        errorAlert("Employee already present");
      }

      const newEmployees = checkedEmployees
        .filter((emp) => !prev.some((e) => e?.id === emp?.id))
        .map((emp) => ({
          id: emp?.id,
          value: emp?.value,
          employees: emp?.Employees,
          is_recommended: true,
        }));

      return [...prev, ...newEmployees];
    });
  }, [recommandedEmployees]);
  return (
    <div>
      <Modal
        open={trainingScheduleModalOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box sx={ModalStyle} className="w-[90%] max-lg:w-[85%] rounded-lg ">
            <div className="">
              <div className=" flex justify-between ">
                <h1 className="font-semibold text-[17px] ">
                  New Training Schedule
                </h1>
                <CloseModalIcon
                  type="button"
                  className="closeButton"
                  onClick={() => (
                    setTrainingScheduleModalOpen(false),
                    reset(defaultValues),
                    setSelectedRow(null),
                    setSelectedEmployees([]),
                    setSelectedRowPatchData(null)
                  )}
                />
              </div>
              <CommonDivider color="E0E0E0" />
              <div>
                <div className="flex w-[32.7%] mt-2">
                  <SearchDropdown
                    control={control}
                    name="training"
                    placeholder="Search by Training*"
                    isSearchable={true}
                    dataArray={trainingNameOptions}
                    isDisabled={isReschedule}
                    searchIcon={true}
                    error={errors.training}
                    handleInputChange={(e) => {
                      const tempCheckChar =
                        e !== null ? UseCheckConsecutiveCharacters(e) : true;
                      if (e !== "" && tempCheckChar) {
                        getAllTrainingName(e)
                          .then((response) => {
                            setTrainingNameOptions(response.data.result);
                          })
                          .catch((error) => {
                            console.log(error);
                          });
                      } else {
                        setTrainingNameOptions([]);
                      }
                    }}
                    onChange={(e) => {
                      if (e !== "") {
                        setSearchString(e);
                      } else {
                        setSearchString(null);
                      }
                    }}
                    isClearable={true}
                  />
                </div>
                <div className="col-span-4 mt-3 p-3 border rounded bg-gray-200 text-sm">
                  <div className="grid grid-cols-3 gap-2">
                    <p>
                      <span className="font-semibold">Training Name : </span>{" "}
                      <span>{selectedTraining?.training}</span>
                    </p>
                    <p>
                      <span className="font-semibold">Training Type : </span>{" "}
                      <span>{selectedTraining?.trainingType || " "}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex gap-1">
                <div className="w-[70%]">
                  <div className="mt-3 grid grid-cols-3 gap-2">
                    <div className="col-span-3 grid grid-cols-3 gap-2">
                      <DatePickerField
                        disablePast={true}
                        // defaultValue={selectedRow !== null && "12-02-2026"}
                        disabled={selectedRow?.edit}
                        name="trainingDate"
                        label="Training Date*"
                        control={control}
                        inputFormat={"dd-MM-yyyy"}
                        slotProps={{ textField: { size: "small" } }}
                        error={errors?.trainingDate}
                      />
                      <TimePickerFieldNew
                        disabled={selectedRow?.edit}
                        error={errors?.fromTime}
                        control={control}
                        name={"fromTime"}
                        label={"From Time*"}
                        slotProps={{ textField: { size: "small" } }}
                        maxTime={watch("toTime")}
                      />
                      <TimePickerFieldNew
                        minTime={watch("fromTime")}
                        disabled={selectedRow?.edit}
                        control={control}
                        error={errors?.toTime}
                        name={"toTime"}
                        label={"To Time*"}
                        slotProps={{ textField: { size: "small" } }}
                      />
                    </div>
                    {selectedTraining?.trainingTypeId === 3 && (
                      <div>
                        <SearchDropdown
                          onChange={() => {}}
                          handleInputChange={() => {}}
                          dataArray={trainerDropdown}
                          control={control}
                          name="trainerName"
                          placeholder="Trainer Name"
                          error={errors.trainerName}
                          isClearable
                          isSearchable
                          menuPlacement="bottom"
                          searchIcon
                          isDisabled={isReschedule}
                        />
                      </div>
                    )}
                    {selectedTraining?.trainingTypeId === 3 && (
                      <div>
                        {/* <fieldset> */}{" "}
                        <ControlledRadioField
                          name="mode"
                          label="Mode"
                          control={control}
                          dataArray={[
                            { label: "Online", id: 1 },
                            { label: "Offline", id: 2 },
                          ]}
                        />
                        {/* </fieldset> */}
                      </div>
                    )}

                    {watchMode && watchMode == 2 && (
                      <div>
                        <DropdownField
                          dataArray={locationDropdown}
                          control={control}
                          name="location"
                          placeholder="Location"
                          error={errors.location}
                          isClearable
                          isSearchable
                          menuPlacement="bottom"
                          searchIcon
                          isDisabled={isReschedule}
                        />
                      </div>
                    )}
                  </div>

                  <div className="grid grid-cols-3 gap-2 mt-3">
                    {/* <SearchDropdown
                  onChange={() => {}}
                  handleInputChange={() => {}}
                  dataArray={roleList}
                  control={control}
                  name="assignRole"
                  placeholder="Assign To Role"
                  error={errors.assignRole}
                  isClearable={true}
                  isSearchable={true}
                  menuPlacement="bottom"
                  searchIcon={true}
                  isDisabled={isReschedule}
                /> */}
                    <SearchDropdown
                      handleInputChange={(e) => {
                        const tempCheckChar =
                          e !== null ? UseCheckConsecutiveCharacters(e) : true;
                        if (e !== "" && tempCheckChar) {
                          getAllEmployeeName(e)
                            .then((response) => {
                              setEmployeeNameOptions(response.data.result);
                            })
                            .catch((error) => {
                              console.log(error);
                            });
                        } else {
                          setEmployeeNameOptions([]);
                        }
                      }}
                      onChange={(e) => {
                        if (e !== "") {
                          setSearchString(e);
                        } else {
                          setSearchString(null);
                        }
                      }}
                      dataArray={employeeNameOptions}
                      control={control}
                      name="assignStaff"
                      placeholder="Assign To Employees"
                      error={errors.applicableRoles}
                      isClearable={true}
                      isSearchable={true}
                      menuPlacement="bottom"
                      isDisabled={isReschedule}
                      searchIcon={true}
                    />
                    <DropdownField
                      // onChange={() => {}}
                      // handleInputChange={() => {}}
                      dataArray={groupDropdown}
                      control={control}
                      name="group"
                      placeholder="Assign To group"
                      error={errors.group}
                      isClearable={true}
                      isSearchable={true}
                      menuPlacement="bottom"
                      isDisabled={isReschedule}
                      searchIcon={true}
                    />
                  </div>

                  {/* <div className="flex justify-end mt-2 text-xs w-[32.7%] ">
                <div className="">Total Count : {selectedEmployees?.length ?? 0}</div>
              </div> */}
                  <div className="md:w-[70%]  mt-2">
                    {selectedEmployees?.length > 0 && (
                      <span className="m-2 text-[12px] flex justify-end font-semibold">
                        Total Count : {selectedEmployees?.length}
                      </span>
                    )}
                    {selectedEmployees?.length > 0 && !spinner ? (
                      <CommonDynamicTableNew
                        renderActions={
                          (selectedRow?.edit === true ||
                            selectedRow === null) &&
                          renderActionsEmp
                        }
                        highlightRow={false}
                        dataResult={selectedEmployees}
                        editableColumns={"Status"}
                        removeHeaders={["id", "value", "is_recommended"]}
                        tableClass="capitalize max-h-[241px] overflow-scroll"
                      />
                    ) : (
                      <>
                        {!spinner && (
                          <div className="flex justify-center my-20 font-bold text-gray-600">
                            <div className="flex flex-col items-center justify-center p-6 space-y-2 animate-fadeIn">
                              <div className="animate-bounce">
                                <NoRecordsIcon className="w-10 h-10 text-gray-400" />
                              </div>

                              <h3 className="text-sm font-semibold text-gray-700 flex items-center">
                                No Records Found
                                <span className="inline-flex ml-1">
                                  <span className="animate-dot1">.</span>
                                  <span className="animate-dot2">.</span>
                                  <span className="animate-dot3">.</span>
                                </span>
                              </h3>
                            </div>
                          </div>
                          // <div className="flex justify-center">
                          //   <h3 className="flex justify-center my-6 font-bold text-gray-600">
                          //     No Records Found...
                          //   </h3>
                          // </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{ mx: 2, my: 2 }}
                />
                <div className="w-[30%]">
                  <div className="m-2 text-[12px] flex justify-between font-semibold">
                    <div>Recommended Employees</div>
                    <div>
                      Total Count :{" "}
                      {recommandedEmployees?.length > 0
                        ? recommandedEmployees?.length
                        : 0}
                    </div>
                  </div>
                  <div className="w-full">
                    {recommandedEmployees?.length > 0 ? (
                      <CommonDynamicTableNew
                        setDataResult={setRecommandedEmployees}
                        SelectCheckbox={true}
                        enableSelectAll={true}
                        // page={page}
                        // rowsPerPage={rowsPerPage}
                        // setPage={setPage}
                        // populateTable={populateTable}
                        // count={count}
                        highlightRow={false}
                        dataResult={recommandedEmployees}
                        // renderActions={renderActionsRecommendedEmp}
                        // renderInput={renderInput}
                        editableColumns={"Status"}
                        tableClass="capitalize max-h-[241px] overflow-scroll"
                        removeHeaders={[
                          "id",
                          "value",
                          "role",
                          "isChecked",
                          "is_recommended",
                        ]}
                      />
                    ) : (
                      <>
                        {!spinner && (
                          <div className="flex justify-center my-20 font-bold text-gray-600">
                            <div className="flex flex-col items-center justify-center p-6 space-y-2 animate-fadeIn">
                              <div className="animate-bounce">
                                <NoRecordsIcon className="w-10 h-10 text-gray-400" />
                              </div>

                              <h3 className="text-sm font-semibold text-gray-700 flex items-center">
                                No Records Found
                                <span className="inline-flex ml-1">
                                  <span className="animate-dot1">.</span>
                                  <span className="animate-dot2">.</span>
                                  <span className="animate-dot3">.</span>
                                </span>
                              </h3>
                            </div>
                          </div>
                          // <div className="flex justify-center">
                          //   <h3 className="flex justify-center my-6 font-bold text-gray-600">

                          //     No Records Found...
                          //   </h3>
                          // </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>{" "}
            <div className="flex gap-2 col-start-4 justify-end mt-auto pt-3 ">
              <CommonButton
                label="Reset"
                onClick={() => {
                  reset(defaultValues);
                  setSelectedEmployees([]);
                  setSelectedRoles([]);
                }}
                className="resetButton px-6 py-2 border border-red-500 text-red-500"
              />
              <CommonButton
                label={selectedRow !== null ? "Update" : "Create"}
                type="submit"
                className="saveButton px-6 py-2 bg-green-700 text-white text-base"
              />
            </div>
          </Box>
        </form>
      </Modal>
      <ConfirmationModal
        confirmationOpen={openPostModal}
        confirmationHandleClose={() => setOpenPostModal(false)}
        confirmationLabel="Confirmation"
        confirmationMsg={`Are you sure you want to ${
          selectedRow !== null ? "update" : "save"
        } this record?`}
        confirmationSubmitFunc={() => {
          handleSaveRecord();
        }}
        confirmationButtonMsg="Save"
      />
    </div>
  );
};

export default TrainingScheduleModal;
